import styled from "styled-components";

const ImageOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
`;

export default ImageOverlay;
